export const ZeusBarTextColorMap: { [key: string]: string } = {
  White: "#ffffff",
  Black: "#333333",
  Blue: "rgb(55,84,139)",
  Red: "#BA0C2F",
  "OD Green": "rgb(64,63,50)",
  Pink: "rgb(217, 68, 133)",
  Orange: "rgb(187,82,47)",
  Purple: "rgb(83,67,110)",
  Green: "rgb(118,148,50)",
  "Light Blue": "rgb(60,114,164)",
  "Desert Tan": "rgb(144,129,105)",
  Gray: "#5b5857",
  Maroon: "rgb(87,40,33)",
  Navy: "rgb(44,54,71)",
};

export const ZeusBarFontFamilyMap: { [key: string]: string } = {
  arimo: "Arimo-Bold, Arimo",
  arvo: "Arvo-Bold, Arvo",
  montserrat: "Montserrat-Bold, Montserrat",
};

export const BarToFontSizeMap: { [key: string]: string } = {
  CUSTOMOHIO_NEW: "68px",
  CUSTOMBELLA_NEW: "64.59px",
  CUSTOMOHIOPOWER_NEW: "51.24px",
};

export type BarOptions = {
  bushing: { val: string };
  sleeve: { val: string };
  shaftColor: { val: string };
  shaftFont: { val: string };
  collarColor: { val: string };
  collarFont: { val: string };
  shaftText: { val: string };
  shaftTextLeft: { val: string };
  shaftTextRight: { val: string };
  shaftImage: { val: string };
  shaftImageLeft: { val: string };
  shaftImageRight: { val: string };
  collarTextTop: { val: string };
  collarTextBottom: { val: string };
};
